import { useState } from "react";
import { useNavigate } from "react-router-dom";
import regionPickerBg from "../images/region-picker/background-1440w.jpg";
import { RegionHotzones } from "./regionhotzones.js";
import { REGIONS, getRegion } from "./regionConfig.js";
import { sendEventToGA } from "./../utils.js";


export function RegionPicker() {
    const navigate = useNavigate();
    const [hoveredRegion, setHoveredRegion] = useState(null);

    const handleRegionClick = (regionKey) => {
        const region = getRegion(regionKey);
        if (!region) return;
        sendEventToGA("landing_page__region__button", "regions", region.label);
        navigate(region.link);
    };

    const handleMiddleClick = (event, regionKey) => {
        if (event.button === 1) {
            const region = getRegion(regionKey);
            if (region) window.open(region.link, "_blank");
        }
    };

    const handleSvgMiddleClick = (regionKey) => {
        const region = getRegion(regionKey);
        if (region) window.open(region.link, "_blank");
    };

    const handleRegionHover = (regionKey) => {
        setHoveredRegion(regionKey);
    };

    const handleRegionLeave = () => {
        setHoveredRegion(null);
    };

    const buttonClass = (regionKey) =>
        `topicButton ${hoveredRegion === regionKey ? 'isActive' : ''}`;

    const renderButtonText = (label) => {
        const [first, ...rest] = label.split(' ');
        return (
            <>
                {first}<br />{rest.join(' ')}
            </>
        );
    };

    return (
        <><div className="regionTitle">Browse Heliosphere Data by Region</div>
        <div className="regionPicker">
        {/* Base image - always visible */}
        <img
          src={regionPickerBg}
          alt="Region picker"
          className="regionPickerImage regionPickerImageBase" />

        {/* One rollover image per region, stacked. Each fades in/out
            independently so transitioning between regions crossfades
            instead of popping. */}
        {REGIONS.map((r) => (
          <img
            key={r.key}
            data-region={r.key}
            src={r.rolloverSrc}
            alt=""
            className="regionPickerImage regionPickerImageRollover"
            style={{
              opacity: hoveredRegion === r.key ? 1 : 0,
              transition: 'opacity 0.25s ease-in-out',
            }}
          />
        ))}

        <RegionHotzones
          onRegionEnter={handleRegionHover}
          onRegionLeave={handleRegionLeave}
          onRegionClick={handleRegionClick}
          onRegionMiddleClick={handleSvgMiddleClick}
        />

        <div className="regionImageContainer">
          <div className="regionRightSide">
            <div className="regionButtonsHolder">
              <div className="regionButtonsRow">

                {REGIONS.map((r) => (
                  <div
                    key={r.key}
                    className={buttonClass(r.key)}
                    title={`Explore the region titled "${r.label}"`}
                    onClick={() => handleRegionClick(r.key)}
                    onMouseDown={(event) => handleMiddleClick(event, r.key)}
                    onMouseEnter={() => handleRegionHover(r.key)}
                    onMouseLeave={handleRegionLeave}
                    onFocus={() => handleRegionHover(r.key)}
                    onBlur={handleRegionLeave}
                    tabIndex="0">
                    <div className={`iconCircle ${r.iconClass}`}>
                      <img src={r.iconSrc} alt={r.label} />
                    </div>
                    <div className="buttonText">
                      {renderButtonText(r.label)}
                    </div>
                  </div>
                ))}

              </div>
            </div>
          </div>
        </div>
      </div></>
    );
}
